import { defineComponent as _defineComponent } from 'vue';
import { useVentureId } from '~/functions/accounts';
import { canEditImpact, useRealUserIsIxAdmin } from '~/functions/impact-locking';
export default /*#__PURE__*/_defineComponent({
  __name: 'SourceAssignmentsInput',
  props: {
    impactGoal: null,
    impact: null
  },
  setup: function setup(__props) {
    var props = __props;
    var ventureId = useVentureId();
    var realUserIsIxAdmin = useRealUserIsIxAdmin();
    var impactEditable = computed(function () {
      return canEditImpact(props.impact, realUserIsIxAdmin.value);
    });
    return {
      __sfc: true,
      props: props,
      ventureId: ventureId,
      realUserIsIxAdmin: realUserIsIxAdmin,
      impactEditable: impactEditable
    };
  }
});